import { MoneyV2 } from "@shopify/hydrogen-react/storefront-api-types";
import { useQuery } from "react-query";
import { api } from "utils/api";
import { artistShopBuilderProductKeys } from "./queryKeys";
import { parseGid } from "../utils/shopifyId";

type ArtistShopBuilderProduct = {
  id: string;
  handle: string;
  productType: string;
  publishedAt?: string;
  templateId: string;
  title: string;
  status: "DRAFT" | "ACTIVE" | "ARCHIVED";
  featuredImage?: {
    altText?: string;
    height?: number;
    url: string;
    width?: number;
  };
};

const getArtistShopBuilderProductList = (artistId?: string) =>
  artistId
    ? api.get<{ data: ArtistShopBuilderProduct[] }>(
        `/artists/${artistId}/shop/products`,
      )
    : Promise.reject(new Error("Invalid artist id"));

const fakeCurrency: MoneyV2 = {
  amount: "0",
  currencyCode: "USD",
};
const fakePriceRange = {
  maxVariantPrice: fakeCurrency,
  minVariantPrice: fakeCurrency,
};

const useArtistShopBuilderProductList = (artistId?: string) =>
  useQuery(
    artistShopBuilderProductKeys.detail(artistId),
    () => getArtistShopBuilderProductList(artistId),
    {
      enabled: !!artistId,
      select: ({ data }) =>
        data.map((p) => {
          const featuredImage = p.featuredImage
            ? {
                altText: p.featuredImage.altText,
                height: p.featuredImage.height,
                url: p.featuredImage.url,
                width: p.featuredImage.width,
                originalSrc: p.featuredImage.url,
                src: p.featuredImage.url,
                transformedSrc: p.featuredImage.url,
              }
            : undefined;
          return {
            ...p,
            id: parseGid(p.id).id,
            gid: p.id,
            artistId,
            featuredImage,
            availableForSale: true,
            priceRange: fakePriceRange,
            compareAtPriceRange: fakePriceRange,
          };
        }),
    },
  );

export { useArtistShopBuilderProductList, type ArtistShopBuilderProduct };
